{
  "R": [0, 10, 136, 255],
  "G": [0, 39, 220, 255],
  "B": [0, 223, 253, 255],
  "A": [0, 48, 64, 70],
  "I": [0, 92, 192, 255]
}
